import React from "react";
import Joi from "joi-browser";
import StatsTable from "./statsTable";
import { getStats } from "../../services/statsService";
import { getUsers } from "../../services/userService";
import { getLeagues } from "../../services/leagueService";
import { getSeasons } from "../../services/seasonService";
import { getMatches } from "./../../services/matchService";
import Form from "../common/form/form";
import _ from "lodash";
import { getCurrentUser } from "../../services/authService";

class Stats extends Form {
  state = {
    data: {
      user: 0,
      league: 0,
      season: 0
    },
    errors: {},
    stats: [],
    users: [],
    leagues: [],
    leagueSeasons: [],
    seasons: []
  };

  schema = {
    user: Joi.number(),
    league: Joi.number(),
    season: Joi.number()
  };

  async componentDidMount() {
    this.setState({
      users: _.orderBy(await getUsers(), "name"),
      leagues: _.orderBy(await getLeagues(), "name"),
      seasons: _.orderBy(await getSeasons(), "name", "desc")
    });

    const matches = await getMatches();
    const match = matches.find(m => m.isFinished === true);

    this.setState({ data: await this.setDefaultValues(match) });

    await this.displayStats(
      this.state.data.user,
      this.state.data.league,
      this.state.data.season
    );
  }

  async componentWillUpdate(nextProps, nextState) {
    let season = nextState.data.season;

    if (this.state.data.league !== nextState.data.league) {
      await this.setSeasons(nextState.data.league);

      if (
        this.state.leagueSeasons.length > 0 &&
        this.state.leagueSeasons.find(ls => ls.id === season) === undefined
      )
        season = this.state.leagueSeasons[0].id;
    }

    if (
      nextState.data.user === this.state.data.user &&
      nextState.data.league === this.state.data.league &&
      season === this.state.data.season
    )
      return;

    await this.displayStats(nextState.data.user, nextState.data.league, season);
  }

  async setSeasons(leagueId) {
    let leagueSeasons = [];

    for (const s in this.state.seasons)
      if (
        this.state.seasons[s].leagues.find(l => l.id === +leagueId) !==
        undefined
      ) {
        leagueSeasons.push(this.state.seasons[s]);
      }

    this.setState({ leagueSeasons });
  }

  async setDefaultValues(match) {
    await this.setSeasons(match.league.id);

    return {
      user: getCurrentUser().id,
      league: match.league.id,
      season: match.season.id
    };
  }

  displayStats = async (user, league, season) => {
    const stats = await getStats(user, league, season);
    this.setState({ stats });

    const data = {
      user: user,
      league: league,
      season: season
    };
    this.setState({ data });
  };

  render() {
    const { stats, users, leagues, leagueSeasons } = this.state;

    return (
      <div>
        <h2>Stats</h2>
        {this.renderSelect("user", "User", users, false)}
        {this.renderSelect("league", "League", leagues, false)}
        {this.renderSelect("season", "Season", leagueSeasons, false)}
        <br />
        <br />
        <StatsTable stats={stats} />
      </div>
    );
  }
}

export default Stats;



// WEBPACK FOOTER //
// ./src/components/stats/stats.jsx